import { Style } from '../models/auto-generated-strapi-types/types/components/Style';

interface GenericPersonalization {
  key?: string;
  styles: Style[];
}

export const getPersonalizationAttribute = (
  object: GenericPersonalization[],
  key: string,
  attributeName: Style['key']
) => {
  return object
    ?.find?.((p) => p?.key === key)
    ?.styles?.find?.((s) => s?.key === attributeName)?.value;
};

export const getPersonalizationAllAttributes = (
  object: GenericPersonalization[],
  key: string
) => {
  return object?.find?.((p) => p?.key === key)?.styles;
};

export const mergePersonalization = (
  theme: any,
  original?: any,
  override?: Style[]
) => {
  return (
    override?.reduce((acc: any, item: Style) => {
      if (item.key) {
        if (acc[theme?.breakpointsMediaQuery?.down(item.size || 'max')])
          acc[theme?.breakpointsMediaQuery?.down(item.size || 'max')][
            item.key
          ] = item.value;
        else
          acc[theme?.breakpointsMediaQuery?.down(item.size || 'max')] = {
            [item.key]: item.value,
          };
      }

      return { ...acc };
    }, original) || original
  );
};
